import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  authConfig: AuthConfig = {};
  constructor(
    private http: HttpClient,
    private oauthService: OAuthService,
    private authService: AuthService,
    private userService: UserInfoService
  ) {
    this.configure();
    this.subscribeToOAuthEvents();
  }

  private async configure() {
    await this.configureGoogleAuth();
    this.oauthService.configure(this.authConfig);
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
    this.oauthService.setupAutomaticSilentRefresh();
  }

  private subscribeToOAuthEvents() {
    this.oauthService.events.subscribe((event) => {
      if (event.type === 'token_received') {
        const userData = {
          accessToken: this.token,
          email: this.identityClaims.email,
          name: this.identityClaims.name,
          picture: this.identityClaims.picture,
          sub: this.identityClaims.sub,
          nickname: this.identityClaims.given_name,
        };

        this.authService.loginWithGoogle(userData).subscribe((user: any) => {
          this.userService.setUserInfo(user);
          window.location.href = '/';
        });
      }

      if (event.type === 'token_expires') {
        console.log('Token is about to expire');
      }

      if (event.type === 'token_error') {
        console.log('Interaction required, redirecting to login...');
        this.oauthService.initLoginFlow();
      }
    });
  }

  public login(): void {
    this.oauthService.initLoginFlow();
  }

  public logout(): void {
    this.oauthService.logOut();
  }

  public get identityClaims(): any {
    return this.oauthService.getIdentityClaims();
  }

  public get token(): string {
    return this.oauthService.getAccessToken();
  }

  public get isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  private async configureGoogleAuth() {
    return this.http.get(`assets/${environment.projectName}/auth/credentials.json`).toPromise().then((response: any) => {
      this.authConfig = {
        issuer: 'https://accounts.google.com',
        redirectUri: window.location.origin + '/ar/login',
        clientId: response.google.clientId,
        scope: 'openid profile email',
        strictDiscoveryDocumentValidation: false,
        useSilentRefresh: true,
        responseType: 'token id_token',
        showDebugInformation: true,
        silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
        silentRefreshTimeout: 5000,
      };
    });
  }
}